import React, { useState, useEffect } from "react";
import labImg from "../../assets/acreddited.jpg";
import cmsApi from "../../services/cmsApi";
import { getImageUrl } from "../../utils/getImageUrl";

const AccreditationSection = () => {
  const [accreditationData, setAccreditationData] = useState({
    title: "REGISTERED AND ACCREDITED BY NACTVET",
    description: "The College is accredited by the National Council for Technical and Vocational Education and Training (NACTVET) to run and grant awards to successful candidates in technician and engineering programmes. Awards offered are Ordinary Diploma, namely the National Technical Level (NTA) 4 – 6. JRIIT is guided by well-defined philosophy and core values. The Institute's philosophy is to become an agent of change in public and private sector by offering quality market- driven academic and professional training and consultancy service. Our core values include customer focus, academic freedom, accountability, competence, excellence fairness, gender equity and diversity as well as integrity.",
    imageUrl: labImg,
    imageAlt: "Engineering students working in the lab",
  });

  // Fetch accreditation content from CMS (client-side only)
  useEffect(() => {
    if (typeof window === 'undefined') return;

    const fetchAccreditationContent = async () => {
      try {
        const result = await cmsApi.getHomepageComponentByType('accreditation');
        if (result.success && result.components.length > 0) {
          const accreditation = result.components[0];
          const settings = accreditation.settings || {};
          
          const defaultDescription = "The College is accredited by the National Council for Technical and Vocational Education and Training (NACTVET) to run and grant awards to successful candidates in technician and engineering programmes. Awards offered are Ordinary Diploma, namely the National Technical Level (NTA) 4 – 6. JRIIT is guided by well-defined philosophy and core values. The Institute's philosophy is to become an agent of change in public and private sector by offering quality market- driven academic and professional training and consultancy service. Our core values include customer focus, academic freedom, accountability, competence, excellence fairness, gender equity and diversity as well as integrity.";
          
          setAccreditationData({
            title: accreditation.title || "REGISTERED AND ACCREDITED BY NACTVET",
            description: accreditation.content || defaultDescription,
            imageUrl: accreditation.mediaUrl || labImg,
            imageAlt: settings.imageAlt || "Engineering students working in the lab",
          });
        }
      } catch (error) {
        console.log('Using default accreditation content:', error.message);
      }
    };

    fetchAccreditationContent();
  }, []);

  return (
    <section className="flex flex-col md:flex-row items-center justify-between pt-16  p-8 bg-gray-100 pb-24 min-[1024px]:max-[1535px]:!pt-12 min-[1024px]:max-[1535px]:!p-6 min-[1024px]:max-[1535px]:!pb-16">
      {/* Left Side: Description */}
      <div className="md:w-1/2 w-full text-left mx-auto max-w-[700px]">
        <h2 className="text-3xl sm:text-2xl md:text-3xl text-center font-bold mb-4 text-custom-pink min-[1024px]:max-[1535px]:!text-2xl min-[1024px]:max-[1535px]:!mb-3">
          {accreditationData.title}
        </h2>
        <span className="inline-block border-solid border-b-4 border-gold mb-4 w-28 h-2 mx-auto md:ml-16 min-[1024px]:max-[1535px]:!mb-3 min-[1024px]:max-[1535px]:!w-24 min-[1024px]:max-[1535px]:!border-b-2"></span>
        <p className="text-lg sm:text-base md:text-lg leading-relaxed font-normal mb-6 text-left tracking-wide md:ml-12 min-[1024px]:max-[1535px]:!text-sm min-[1024px]:max-[1535px]:!mb-4">
          {accreditationData.description}
        </p>
      </div>

      {/* Right Side: Image */}
      <div className="md:w-1/2 w-full mt-8 md:mt-0">
        <img
          src={getImageUrl(accreditationData.imageUrl)}
          alt={accreditationData.imageAlt}
          className="w-full sm:w-4/5 h-auto object-cover rounded-lg shadow-lg mx-auto md:mx-0"
          onError={(e) => {
            console.error('Failed to load accreditation image:', accreditationData.imageUrl);
            e.currentTarget.src = labImg;
          }}
        />
      </div>
    </section>
  );
};

export default AccreditationSection;
